import React from "react";
import { Radio, X } from "lucide-react";

import { formatRelativeTime } from "../../../utils/datetime/formatRelativeTime";
import { EllipsisMenu } from "../../menu/ellipsis/EllipsisMenu";

import "./StreamThumbnailCard.css";

const StreamThumbnailCard = ({
  stream,
  image,
  badgeLabel,
  badgeVariant = "default",
  isLive = false,
  canPlay = false,

  showMenuButton = false,
  menuOptions = [],

  onClick,

  isOpen = false,
  onClose,

  modalTitle,
  modalMessage,
  modalMeta,

  className = "",
}) => {
  const title = stream?.title || "Untitled Stream";
  const username = stream?.username;
  const createdAt = stream?.createdAt;

  const showMeta = Boolean(username || createdAt);
  const showMenu = showMenuButton && menuOptions.length > 0;

  const cardClassName = [
    "stream-thumbnail-card",
    `stream-thumbnail-card--${badgeVariant}`,
    canPlay && "stream-thumbnail-card--playable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleCardClick = () => {
    onClick?.(stream);
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      <article className={cardClassName} onClick={handleCardClick}>
        <div className="stream-thumbnail-card__media">
          {image ? (
            <img src={image} alt={`${title} thumbnail`} />
          ) : (
            <div className="stream-thumbnail-card__placeholder">
              <Radio size={24} />
            </div>
          )}

          {badgeLabel && (
            <div
              className={`stream-thumbnail-card__badge stream-thumbnail-card__badge--${badgeVariant}`}
            >
              {isLive && <span className="stream-thumbnail-card__pulse" />}
              {badgeLabel}
            </div>
          )}

        </div>

        <div className="stream-thumbnail-card__body">
          <div className="stream-thumbnail-card__main">
            <h3>{title}</h3>

            {showMeta && (
              <div className="stream-thumbnail-card__meta">
                {username && (
                  <span className="stream-thumbnail-card__username">
                    {username}
                  </span>
                )}

                {username && createdAt && (
                  <span className="stream-thumbnail-card__divider">•</span>
                )}

                {createdAt && (
                  <span className="stream-thumbnail-card__created-at">
                    {formatRelativeTime(createdAt)}
                  </span>
                )}
              </div>
            )}
          </div>

          {showMenu && (
            <div
              className="stream-thumbnail-card__actions"
              onClick={stopPropagation}
            >
              <EllipsisMenu options={menuOptions} position="right" />
            </div>
          )}
        </div>
      </article>

      {isOpen && (
        <div
          className="stream-not-ready-modal"
          role="dialog"
          aria-modal="true"
          aria-label={modalTitle || "Stream information"}
          onClick={onClose}
        >
          <div className="stream-not-ready-modal__overlay" />

          <div
            className="stream-not-ready-modal__card"
            onClick={stopPropagation}
          >
            <button
              type="button"
              className="stream-not-ready-modal__close"
              onClick={onClose}
              aria-label="Close"
            >
              <X size={17} />
            </button>

            {badgeLabel && (
              <div className="stream-not-ready-modal__badge">{badgeLabel}</div>
            )}

            <h3>{modalTitle || title}</h3>

            <p>{modalMessage || "This stream is not available yet."}</p>

            {modalMeta && (
              <span className="stream-not-ready-modal__meta">{modalMeta}</span>
            )}

            <button
              type="button"
              className="stream-not-ready-modal__button"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default StreamThumbnailCard;
